function showLowStockBannerCart() {
  const items = document.querySelectorAll('.line-item');
  const banner = document.querySelector('.cart-drawer-low-stock-text');

  if (!banner) return;

  let hasDiscount = false;

  items.forEach((item) => {
    const price = parseFloat(item.dataset.price);
    const compare = parseFloat(item.dataset.compare);

    if (compare > price) {
      hasDiscount = true;
    }
  });

  banner.style.display = hasDiscount ? 'flex' : 'none';
}


document.addEventListener('DOMContentLoaded', showLowStockBannerCart);

const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer) {
  const observer = new MutationObserver(() => {
    showLowStockBannerCart();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('cart:change', showLowStockBannerCart);
document.addEventListener('variant:add', showLowStockBannerCart);